import { useEffect, useRef } from 'react';
import If from '@/components/If';
import { useScript, State } from '@/hooks/useScript';

type BoxType = 'regular' | 'small';

export interface TrustBoxProps {
  boxType?: BoxType;
}

export const TrustBox = ({ boxType }: TrustBoxProps) => {
  const trustPilotScriptStatus = useScript(
    '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js',
    {
      crossOrigin: undefined,
    }
  );
  const widgetContainer = useRef(null);
  useEffect(() => {
    if (trustPilotScriptStatus === State.READY) {
      const typedWindow = window as Window;
      if (typedWindow.Trustpilot) {
        typedWindow.Trustpilot.loadFromElement(widgetContainer.current, true);
      }
    }
  }, [trustPilotScriptStatus]);
  return (
    <>
      <If match={!boxType || boxType === 'regular'}>
        <div
          ref={widgetContainer}
          className="trustpilot-widget"
          data-locale="en-US"
          data-template-id="539ad60defb9600b94d7df2c"
          data-businessunit-id="5959f23c0000ff0005a5d8bf"
          data-style-height="500px"
          data-style-width="100%"
          data-theme="light"
          data-stars="4,5"
        >
          <a
            href="https://www.trustpilot.com/review/simplywall.st"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            Trustpilot
          </a>
        </div>
      </If>
      <If match={boxType === 'small'}>
        <div
          ref={widgetContainer}
          data-locale="en-AU"
          data-template-id="5419b6ffb0d04a076446a9af"
          data-businessunit-id="5959f23c0000ff0005a5d8bf"
          data-style-height="50px"
          data-style-width="100%"
          data-theme="light"
        >
          <a
            href="https://au.trustpilot.com/review/simplywall.st"
            target="_blank"
            rel="noopener noreferrer nofollow"
          >
            Trustpilot
          </a>
        </div>
      </If>
    </>
  );
};
